import log from 'loglevel';
import VhyReporter from '@vhallyun/log-reporter';
/**
 * 验证容器类型是否符合要求
 * @export
 * @param {*} type
 * @returns
 */
export function verifyContainerType(type) {
  return (target, name, descriptor) => {
    const method = descriptor.value;
    descriptor.value = function (...args) {
      if (!this.currentDoc.container) {
        const msg = `无法执行${name}方法，容器实例为空`;
        log.error(msg);
        VhyReporter.scout(260012, { msg });
        return;
      }
      const oType = this.currentDoc.container.type;
      if (oType !== type) {
        log.warn(`无法在 ${oType} 实例上执行 ${name} 方法，该方法存在于 ${type} 实例上`);
        return;
      }

      return method.apply(this, args);
    };
  };
}

/**
 * 回放限定方法
 *
 * @export
 * @returns
 */
export function LimitInVod() {
  return (target, name, descriptor) => {
    const method = descriptor.value;
    descriptor.value = function (...args) {
      if (!this.isVod) {
        let CLASS_NAME = target.constructor.name;
        log.error(
          `Method call failed, only used in Vod mode, before call method ${name}, you should set ${CLASS_NAME} instance property: isVod to true.`
        );
        return;
      }

      return method.apply(this, args);
    };
  };
}

/**
 * 判断doc对象是否为空
 *
 * @export
 * @returns
 */
export function InitializedAssert() {
  return (target, name, descriptor) => {
    const method = descriptor.value;
    descriptor.value = function (...args) {
      if (!this.currentDoc || !this.currentDoc.container) {
        const msg = `当前容器为空，无法执行${name}方法`;
        log.error(msg);
        VhyReporter.scout(260012, { msg });
        return;
      }
      return method.apply(this, args);
    };
  };
}

export function SetCurrentDoc() {
  return (target, name, descriptor) => {
    const method = descriptor.value;
    descriptor.value = function (...args) {
      if (args.length !== 0) {
        const { id } = args[0];
        if (id) {
          this._currentDoc = this.docMap.get(id);
        } else {
          // this._currentDoc = null
        }
      }
      return method.apply(this, args);
    };
  };
}
